import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';

import { useReactNativeWebView } from 'src/shared/hooks';
import { WebViewScope } from 'src/shared/hooks/useReactNativeWebView';

interface BaseWebViewMessagePayload {
  app: string;
  action: string;
}

interface NavigateMessagePayload extends BaseWebViewMessagePayload {
  action: 'navigate';
  path: string;
}

type WebViewMessagePayload = NavigateMessagePayload;

export const useWebViewListener = () => {
  const history = useHistory();
  const isWebView = useReactNativeWebView(WebViewScope.MOBILE_HOMEOWNER);

  const messageListener = useCallback(
    (message: MessageEvent<unknown>) => {
      let payload;

      try {
        if (typeof message.data === 'string') {
          payload = JSON.parse(message.data ?? '{}') as WebViewMessagePayload;
        }

        if (typeof payload === 'object' && payload.app === 'homeowner') {
          if (payload.action === 'navigate' && payload.path) {
            history.push(payload.path);
          }
        }
      } catch {
        // do nothing
      }
    },
    [history],
  );

  // setup listener if in webview
  useEffect(() => {
    if (isWebView) {
      window.addEventListener('message', messageListener);
    }

    return () => window.removeEventListener('message', messageListener);
  }, [isWebView, messageListener]);
};
